module.exports = __webpack_public_path__ + "img/stock4.a3c48d2f.png";